module.exports = __webpack_public_path__ + "static/media/technology-tech1.4cf9fe50.jpg";